// extracted by mini-css-extract-plugin
export default {"table":"PatientConsentPrograms_table__STG9u","actionSeparator":"PatientConsentPrograms_actionSeparator__PO8Y3","actionRemove":"PatientConsentPrograms_actionRemove__0Dsa5"};